/**
 * Player list helpers (admin tools, 2026-10-08). `GET /admin/players` pages (`{items, total, testMatches, offset, take}`) and
 * leaves test accounts out unless `includeTest`; these helpers are the list's wording, kept pure for tests.
 */

/** Rows per page of the player list. */
export const PLAYER_PAGE_SIZE = 50;

/** "Showing 1-50 of 212" ("No players match." for none). */
export function showingText(offset: number, count: number, total: number): string {
  if (total === 0) return 'No players match.';
  if (count === 0) return `Showing 0 of ${total}`;
  return `Showing ${offset + 1}-${offset + count} of ${total}`;
}

/**
 * The hint under the list while test accounts are hidden: "3 test accounts match", or null when none match or they're
 * already shown.
 */
export function hiddenTestText(testMatches: number, includeTest: boolean): string | null {
  if (includeTest || testMatches <= 0) return null;
  return `${testMatches} test account${testMatches === 1 ? '' : 's'} match`;
}

/** A last-activity time as "5 min ago", "3 h ago", "2 d ago", or "never". */
export function lastActiveLabel(at: string | null | undefined, now: Date = new Date()): string {
  if (!at) return 'never';
  const minutes = Math.max(0, Math.round((now.getTime() - new Date(at).getTime()) / 60000));
  if (minutes < 60) return `${minutes} min ago`;
  const hours = Math.round(minutes / 60);
  if (hours < 48) return `${hours} h ago`;
  return `${Math.round(hours / 24)} d ago`;
}
